import {
  doPostCartItem,
  doPostSessionCartItem,
  doFetchQuote,
  doFetchCartProducts,
  doFetchTotalAmt,
  doDeleteCartProduct,
  doPutCartItem,
  doPutMiniCartItem,
  doFetchCartId,
  doPutConfiguredCartItem,
  doPutGiftCartItem,
  doQtyUpdateCartItem,
  doUpdateCCProductQuantity
} from "@/services/guest_cart.service";
import {
  getProductOptionByType,
  isStrictNonZeroDecimal
} from "@/services/util.service";
import { doFetchList } from "@/services/session_item.service";
import { doFetchByDesignProjectId } from "@/services/session.service";
import { getField, updateField } from "vuex-map-fields";
import humps from "lodash-humps";
import { getCookieByName, setCookieByName } from "@/services/auth";
const crGuestQuoteId = import.meta.env.VITE_APP_GUEST_QUOTE_ID;
export const cartProduct = {
  namespaced: true,
  state: {
    cartDrawer: false,
    inProgress: false,
    fetchInProgress: false,
    cartProduct: [],
    cartProductList: [],
    productTotalAmt: [],
    productMedia: {},
    errorMessage: null,
    cartProductsProgress: false,
    cartTotalAmtProgress: false,
    guestQuoteId: getCookieByName(crGuestQuoteId),
    giftCartDetailsGuest: {
      senderNameGuest: "",
      senderEmailGuest: "",
      recipientNameGuest: "",
      recipientEmailGuest: "",
      senderMessageGuest: "",
      //"giftCardQty": "",
      giftCardAmtGuest: ""
    },
    giftMessageData: {}
  },
  getters: {
    getField
  },
  mutations: {
    updateField,

    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    cartProductsProgress(state, yesOrNo) {
      state.cartProductsProgress = yesOrNo;
    },
    cartTotalAmtProgress(state, yesOrNo) {
      state.cartTotalAmtProgress = yesOrNo;
    },
    setCartDrawer(state, yesOrNo) {
      state.cartDrawer = yesOrNo;
    },
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setCartProduct(state, product) {
      state.cartProduct = product;
    },
    setCartProductList(state, list) {
      state.cartProductList = list;
    },
    setProductAmt(state, amt) {
      state.productTotalAmt = amt;
    },
    setProductsMedia(state, media) {
      state.productMedia = media;
    },
    setErrorMessage(state, err) {
      state.errorMessage = err;
    },
    setGuestQuoteId(state, quote) {
      state.guestQuoteId = quote;
    },
    updateCartItem(state, { index, data }) {
      state.cartProductList[index] = {
        ...state.cartProductList[index],
        ...data
      };
    }
  },
  actions: {
    addToCart: async ({ commit }, data) => {
      try {
        commit("inProgress", true);
        let cartProduct = null;
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          const guestQuote = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuote);
          cartProduct = await doPostCartItem(
            data.sku,
            data.qty,
            data.price,
            data.personalizedData,
            guestQuote,
            data.builderId
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            const cartProductList = await doFetchCartProducts(guestQuote);
            if (cartProductList) {
              commit("setCartProductList", humps(cartProductList));
              const productTotalAmt = await doFetchTotalAmt(guestQuote);
              if (productTotalAmt) {
                commit("setProductAmt", humps(productTotalAmt));
              }
            }
          }
        } else {
          cartProduct = await doPostCartItem(
            data.sku,
            data.qty,
            data.price,
            data.personalizedData,
            guestQuoteId,
            data.builderId
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            const cartProductList = await doFetchCartProducts(guestQuoteId);
            if (cartProductList) {
              commit("setCartProductList", humps(cartProductList));
              const productTotalAmt = await doFetchTotalAmt(guestQuoteId);
              if (productTotalAmt) {
                commit("setProductAmt", humps(productTotalAmt));
              }
            }
          }
        }
        commit("inProgress", false);
        // commit('setCartDrawer', true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchGuestQuote: async ({ commit }) => {
      commit("inProgress", true);
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      if (!guestQuoteId) {
        guestQuoteId = await doFetchQuote();
        setCookieByName(crGuestQuoteId, guestQuoteId);
        commit("setGuestQuoteId", guestQuoteId);
        commit("inProgress", false);
      }
      commit("inProgress", false);
      return guestQuoteId;
    },

    addSessionProductToCart: async (
      { commit },
      { sku, qty, enteredOptions }
    ) => {
      try {
        commit("inProgress", true);
        let cartProduct = null;
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          guestQuoteId = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuoteId);
          cartProduct = await doPostSessionCartItem({
            sku,
            qty,
            enteredOptions,
            guestQuoteId: guestQuoteId
          }); // builderId
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            const cartProductList = await doFetchCartProducts(guestQuoteId);
            if (cartProductList) {
              commit("setCartProductList", humps(cartProductList));
              const productTotalAmt = await doFetchTotalAmt(guestQuoteId);
              if (productTotalAmt) {
                commit("setProductAmt", humps(productTotalAmt));
              }
            }
          }
        } else {
          cartProduct = await doPostSessionCartItem({
            sku,
            qty,
            enteredOptions,
            guestQuoteId
          }); // builderId
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            const cartProductList = await doFetchCartProducts(guestQuoteId);
            if (cartProductList) {
              commit("setCartProductList", humps(cartProductList));
              const productTotalAmt = await doFetchTotalAmt(guestQuoteId);
              if (productTotalAmt) {
                commit("setProductAmt", humps(productTotalAmt));
              }
            }
          }
        }
        commit("inProgress", false);
        // commit('setCartDrawer', true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    productTotalAmt: async ({ commit }, guestQuoteId) => {
      commit("cartTotalAmtProgress", true);
      doFetchTotalAmt(guestQuoteId)
        .then((productTotalAmt) => {
          commit("cartTotalAmtProgress", false);
          commit("setProductAmt", humps(productTotalAmt));
        })
        .catch(() => commit("cartTotalAmtProgress", false));
    },
    cartProductList: async ({ commit, dispatch }, guestQuoteId) => {
      try {
        commit("setCartProductList", []);
        commit("cartProductsProgress", true);
        let cartProductDetails = await doFetchCartId(guestQuoteId);
        if (cartProductDetails) {
          let cartProductList = await doFetchCartProducts(
            cartProductDetails.id
          );
          //let newCartProductList=[];
          if (cartProductList.length > 0) {
            for (let i = 0; i < cartProductList.length; i++) {
              if (
                cartProductList[i] &&
                cartProductList[i].customizable_options &&
                cartProductList[i].customizable_options.length
              ) {
                let optionsList = cartProductList[i].customizable_options;
                let builderSessionOne = null;
                builderSessionOne = optionsList.find(
                  (x) => x.label == "BuilderSessionId"
                );
                let designProjectId = optionsList.find(
                  (x) => x.label == "DESIGN_PROJECT_ID"
                );
                if (builderSessionOne) {
                  let sessionId = builderSessionOne.values[0].value;
                  if (sessionId) {
                    const sessionData = await doFetchList({ sessionId });
                    if (sessionData && sessionData.length > 0) {
                      let thumbnailUrl = sessionData.map(
                        (a) => a.thumbnail_url
                      );
                      let itemId = sessionData.map((a) => a.id);
                      cartProductList[i]["thumbnail_url"] = thumbnailUrl;
                      cartProductList[i]["item_ids"] = itemId;
                    }
                  }
                } else if (designProjectId) {
                  let value = designProjectId.values[0].value;
                  if (value) {
                    console.log("designProjectId", value);
                    try {
                      let response = await doFetchByDesignProjectId({
                        designProjectId: value
                      });
                      let builderSession =
                        response.length > 0 ? response[0] : null;
                      if (builderSession.order_state == "prepare_svg") {
                        if (
                          builderSession &&
                          builderSession.builder_session_item.length > 0
                        ) {
                          let builderSessionItemList =
                            builderSession.builder_session_item.map((item) => ({
                              ...item,
                              thumbnailUrl: null
                            }));

                          cartProductList[i]["builderSessionItemList"] =
                            builderSessionItemList;
                        }

                        dispatch("pollSessionData", {
                          designProjectId: value,
                          index: i
                        });
                      } else {
                        console.log(
                          "builderSession order state change",
                          builderSession.order_state
                        );
                        if (
                          builderSession &&
                          builderSession.builder_session_item.length > 0
                        ) {
                          let builderSessionItemList =
                            builderSession.builder_session_item;
                          cartProductList[i]["builderSessionItemList"] =
                            builderSessionItemList;
                        }
                      }
                    } catch (error) {
                      console.log(
                        "error in fetching design based session fetch",
                        error
                      );
                    }
                  }
                }
              }
            }
          }
          commit("setCartProductList", humps(cartProductList));
          commit("cartProductsProgress", false);
          return humps(cartProductList);
        }
      } catch (err) {
        console.log("error in cart process", err);
        commit("setCartProductList", []);
        commit("cartProductsProgress", false);
      }
    },
    removeCartProduct: async ({ commit, dispatch }, productId) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        let trueOrFalse = await doDeleteCartProduct(productId, guestQuoteId);
        if (trueOrFalse) {
          commit("cartProductsProgress", false);
          // commit('setCartDrawer', false);
          await dispatch("cartProductList", guestQuoteId);
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToPersonalizeCartItem: async (
      { commit, dispatch },
      {
        qty,
        itemId,
        perosonalizeIdValue,
        orderTotal = null,
        productOptions,
        byType,
        optionIdType,
        updateToCC = false,
        perosonalizeId = null
      }
    ) => {
      try {
        let guestQuoteId = getCookieByName(crGuestQuoteId);

        // Fetch guest quote only if not exists
        if (!guestQuoteId) {
          guestQuoteId = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuoteId);
        }

        // Update Crane Connection order quantity
        let totalPrice = "" + orderTotal;
        if (updateToCC) {
          let responseData = await doUpdateCCProductQuantity({
            orderNumber: perosonalizeIdValue,
            quantity: qty
          });
          const match = responseData.data.match(/price\s+is:\s*(\d+)/i);
          const price = match ? Number(match[1]) : null;
          totalPrice = "" + price;
        }

        if (!isStrictNonZeroDecimal(totalPrice)) {
          throw "Error in updating cart quntity, please try again later.";
        }

        if (!perosonalizeId) {
          throw "Error in updating cart quntity, please try again later.";
        }
        const customOptions = [
          { name: perosonalizeId, value: perosonalizeIdValue },
          { name: "custom_price", value: totalPrice }
        ];

        const customizableOptions = getProductOptionByType({
          productOptions,
          customOptions,
          action: "update",
          optionIdType: optionIdType,
          byType: byType
        });

        // Update cart item quantity
        const cartProduct = await doQtyUpdateCartItem({
          qty: qty,
          quoteId: guestQuoteId,
          itemId: itemId,
          customizableOptions: customizableOptions
        });

        if (!cartProduct) return null;

        commit("setCartProduct", cartProduct);

        return cartProduct;
      } catch (err) {
        console.error("update to cart failed:", err);
        throw err;
      }
    },
    updateToConfiguredCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        const cartProduct = await doPutConfiguredCartItem(
          data.sku,
          data.qty,
          guestQuoteId,
          data.itemId,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          //commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          await dispatch("cartProductList", guestQuoteId);
          await dispatch("productTotalAmt", guestQuoteId);
        }
      } catch (err) {
        await dispatch("cartProductList", guestQuoteId);
        await dispatch("productTotalAmt", guestQuoteId);
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToGiftCart: async ({ commit, dispatch, state }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);

      try {
        commit("inProgress", true);
        const cartProduct = await doPutGiftCartItem(
          data,
          guestQuoteId,
          state.giftCartDetailsGuest
        );
        if (cartProduct) {
          commit("inProgress", false);
          if (data.routeName != "CartProducts") {
            //  commit('setCartDrawer', true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          dispatch("productTotalAmt", guestQuoteId);
        }
      } catch (err) {
        dispatch("cartProductList", guestQuoteId);
        dispatch("productTotalAmt", guestQuoteId);
        commit("inProgress", false);
        throw err;
      }
    },

    updateMiniCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        const cartProduct = await doPutMiniCartItem(
          data.sku,
          data.qty,
          guestQuoteId,
          data.itemId,
          data.ccid,
          data.price,
          data.personalizeDetails,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          // commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          await dispatch("cartProductList", guestQuoteId);
          await dispatch("productTotalAmt", guestQuoteId);
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList", guestQuoteId);
        await dispatch("productTotalAmt", guestQuoteId);
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("inProgress", true);
        const cartProduct = await doPutCartItem(
          data.sku,
          data.qty,
          guestQuoteId,
          data.price,
          data.itemId,
          data.personalizedData
        );
        if (cartProduct) {
          commit("inProgress", false);
          // commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          dispatch("productTotalAmt", guestQuoteId);
        }
      } catch (err) {
        await dispatch("cartProductList", guestQuoteId);
        await dispatch("productTotalAmt", guestQuoteId);
        commit("inProgress", false);
        throw err;
      }
    },
    updateSessionProductToCart: async (
      { commit, dispatch },
      { qty, itemId, enteredOptions }
    ) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("inProgress", true);
        const cartProduct = await doQtyUpdateCartItem({
          quoteId: qty,
          guestQuoteId,
          itemId,
          enteredOptions
        });
        if (cartProduct) {
          commit("inProgress", false);
          // commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          dispatch("productTotalAmt", guestQuoteId);

          return humps(cartProduct);
        }
      } catch (err) {
        await dispatch("cartProductList", guestQuoteId);
        await dispatch("productTotalAmt", guestQuoteId);
        commit("inProgress", false);
        throw err;
      }
    },

    cartDrawer: async ({ commit }, flag) => {
      commit("setCartDrawer", flag);
    },
    pollSessionData: async (
      { commit },
      { designProjectId, index, interval = 2000, maxTries = 20 }
    ) => {
      let tries = 0;

      const pollInterval = setInterval(async () => {
        try {
          tries++;
          let response = await doFetchByDesignProjectId({
            designProjectId
          });
          let builderSession = response.length > 0 ? response[0] : null;
          console.log("builderSession order state", builderSession.order_state);
          if (builderSession.order_state !== "prepare_svg") {
            console.log(
              "builderSession order state changed",
              builderSession.order_state
            );
            clearInterval(pollInterval);
            if (
              builderSession &&
              builderSession.builder_session_item.length > 0
            ) {
              let builderSessionItemList =
                builderSession.builder_session_item.map((item) => ({
                  ...item,
                  thumbnailUrl: item.thumbnail_url
                }));

              commit("updateCartItem", {
                index: index,
                data: { builderSessionItemList: builderSessionItemList }
              });
            }
          } else if (tries >= maxTries) {
            console.warn(
              "Session data not found after 10 tries, stopping poll."
            );
            clearInterval(pollInterval);
          }
        } catch (err) {
          console.error("Error polling session data:", err);
          clearInterval(pollInterval);
        }
      }, interval);

      return pollInterval; // so you can clear it manually if needed
    }
  }
};
